import { Form } from '@mairistem/composants';
import { Combobox, Panel } from '@mairistem/finances-utils';
import React from 'react';
import { MULTI } from '@mairistem/comptabilite';
import PanelComponentProps from '../../../interfaces/pieces/mouvements/panelComponentProps';

const RegieComponent = ({
  data,
  handlePin,
  onChange,
  panel,
}: PanelComponentProps) => {
  const handleChange = (e, { name, value }) => onChange?.({ [name]: value }, panel);

  return (
    <Panel panel={panel} onPin={handlePin}>
      <Form>
        <Form.Group>
          <Form.Field
            control={Combobox}
            data-testid="regieDropdown"
            key="identifiantRegie"
            label="Nom de la régie"
            // @ts-expect-error
            name="identifiantRegie"
            onChange={handleChange}
            options={data?.regies}
            placeholder={data?.identifiantRegie === MULTI ? MULTI : ''}
            search
            selection
            value={data?.identifiantRegie}
            width={16}
          />
        </Form.Group>
      </Form>
    </Panel>
  );
};

export default RegieComponent;
